<app-generic-loading *ngIf="isLoading"></app-generic-loading>

<div class="ui-g-12" *ngIf="!isLoading">
  <p-chart type="line" [options]="options" [data]="data"></p-chart>
</div>

